import Filters from "./filters.json";

const RoomPlanConfig = {
  Filters,
};

export default RoomPlanConfig;
